<template>
  <div class="general-info-detail-wrap center-setting">
    <!-- <Breadcrumb :options="crumbOptions"></Breadcrumb> -->
    <div class="header-wrap">
      <div class="title">{{result.title}}</div>
      <div class="other">
        <span class="time">发布时间：{{result.publishTime}}</span>
        <span class="white"></span>
        <span class="origin">来源：{{result.createBy}}</span>
      </div>
    </div>
    <div class="content"
         v-html="result.content"></div>
    <!-- <div class="fileVos">
      <MediaWrap v-for="item in result.fileVo"
                 :key="item.id"
                 :url="item.filePath"
                 :height="200"
                 :isViewer="true"></MediaWrap>
    </div> -->
    <div class="anneId">
      <a v-for="item in result.fileAnnes"
         :key="item.id"
         :href="item.filePath"
         :download="item.fileName">{{item.fileName}}</a>
    </div>
  </div>
</template>
<script>
import { checkMGeneralInfo, updateViews } from '@/api/MGeneralInfo'
import mixinsBackStack from '@/views/backstageSupport/mixins'
// import Breadcrumb from '@/components/common/Breadcrumb'
import { getCurrentCrumb } from '@/utils/crumb.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      result: {},
      crumbOptions: [],
    }
  },
  components: {
    // Breadcrumb
  },
  created() {
    this.loadData()
    this.settingCrumb()
    this.addViews()
  },
  methods: {
    // 设置面包屑
    settingCrumb() {
      const { path } = this.$route
      const crumbOptions = getCurrentCrumb(path)
      this.crumbOptions = crumbOptions
    },
    async addViews() {
      const { id } = this.$route.query
      await updateViews(id)
    },
    async loadData() {
      const { id } = this.$route.query
      const { data } = await checkMGeneralInfo(id)
      // 处理时间格式
      this.handlerDateFormat([data])
      this.result = data
    },
  },
}
</script>
